var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"faq_list"},_vm._l((_vm.contactData),function(item){return _c('li',[_c('Category',{attrs:{"category":item.searchWords,"label":item.displayText,"iconPath":item.iconFilePath}})],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }